import Axios from 'axios'
import { SERVER_BASE_URL } from './baseUrl'
export const createPaymentIntent = async (
  token: any,
  amount: any,
  connectedAccountID: any,
  feeAmount: any,
  visiteId: any,
) => {
  try {
    const response = await Axios.post(
      `${SERVER_BASE_URL}api/paiement/create-payment-intent`,
      { amount, connectedAccountID, feeAmount, visiteId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    const { clientSecret } = response.data

    return { success: true, clientSecret }
  } catch (error: any) {
    return { success: false, message: error.response.data.error }
  }
}

export const validerCompteRendu = async (
  token: string,
  params: { payment_intent_id?: string; visiteId?: number } | string,
) => {
  try {
    const payload = typeof params === 'string' ? { payment_intent_id: params } : { ...params }

    const response = await Axios.post(
      `${SERVER_BASE_URL}api/paiement/valider-compte-rendu`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error, params)
    throw error
  }
}

export const verifyIdentity = async (id: any) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/paiement/verifyIdentity?id=${id}`)

    return response
  } catch (error) {
    console.error('Erreur lors de la vérif identity', error)
  }
}

export const verifyInfosAccountStripe = async (id: any) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/paiement/verifyAccountInfos?id=${id}`)

    return response
  } catch (error) {
    console.error('Erreur lors de la vérif stripe', error)
  }
}

export const getAuthLink = async (token: any, id: any, email: any) => {
  try {
    const response = await Axios.post(
      `${SERVER_BASE_URL}api/paiement/getLink`,
      { id, email },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data.lien
  } catch (error) {
    console.error('Erreur lors de la récupération du link', error)
  }
}

export const refundPayment = async (token: any, visiteId: any) => {
  try {
    const response = await Axios.post(
      `${SERVER_BASE_URL}api/paiement/refund`,
      { visiteId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return response as any
  } catch (error) {
    console.error('Erreur lors du remboursement', error)
  }
}
